import React from 'react';
import imgResolver from '../utils/img-resolver';
import moment from 'moment';
import 'moment-timezone';
import withRouter from '../utils/with-router';
import reportTime from '../utils/reportTime';
import checkOverflow from '../utils/checkModalOverflow';

@withRouter
class FinishModal extends React.Component {

    render() {
        checkOverflow(this.props.isVisible);
        const shift = this.props.shift[0] || {};
        let classes = "modal-overlay finish-shift-modal-overlay";
        if (this.props.isVisible) classes += " active";
        let pos = '';
        if (typeof shift.position !== 'undefined') {
            pos = shift.position.name;
        }

        let shift_start = moment();
        if (shift.start_time) {
            shift_start = moment(shift.start_time).tz(shift.company.timezone);
        }

        return (
            <div onClick={this.toggleModal.bind(this, shift.id)} className={classes}>
                <div onClick={this.modalClick.bind(this)} className="modal whitebox">
                    <div className="modal-content">
                        <button className="close" onClick={this.toggleModal.bind(this, shift.id)}><span>&times;</span></button>
                        <img className="header-img" src={require('../styles/images/finish_shift.png')} alt="" />
                        <h1 className="title">Its time to finish up your shift</h1>
                        <p>Rate the professionals, complete the timesheets by entering the actual hours and confirm the shift.</p>
                        <div>
                            <div className="shift">
                                <h4 className="shift-title">{shift.workers_needed} {pos} - {shift.venue} - {shift_start.format('DD.MM.YYYY')} </h4>
                                <div className="shift-info">
                                    Hired: {shift.candidates_hired} {shift.candidates_hired == 1 ? 'person' : 'people' } | {shift_start.format('MMM DD[.]')} - {this.getTimes(shift)}
                                </div>
                            </div>
                        </div>

                        <div className="buttons">
                            <button onClick={this.finishShift.bind(this, shift.id)} className="btn btn-small btn-green btn-finish-shift">Finish shift</button>
                            <button onClick={this.remindLater.bind(this, shift.id)} className="btn-transparent btn-remind-later">REMIND ME LATER</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getTimes(shift) {
        if (shift.start_time && shift.end_time) {
            let start_time = moment(shift.start_time).tz(shift.company.timezone);
            let end_time = moment(shift.end_time).tz(shift.company.timezone);
            return reportTime(start_time, end_time);
        }
    }

    modalClick(evt) {
        evt.stopPropagation();
    }

    finishShift(shiftId) {
        // Toggle modal first so that the .has-modal gets removed properly and then transition to the next page.
        // Otherwise finish shift page is not scrollable.
        this.props.toggleModal(shiftId, true, () => {
            this.context.router.transitionTo('finish_shift', {shiftId});
        });
    }

    toggleModal(shiftId) {
        this.props.toggleModal(shiftId);
    }

    remindLater(shiftId) {
        this.props.remindLater(shiftId);
        this.props.toggleModal(shiftId);
    }
}

export default FinishModal;



/** WEBPACK FOOTER **
 ** ./app/src/components/FinishModal.js
 **/